import { createContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { RSimInventoryItem, RSimsData } from 'src/rSimInventory/constants/rsim';

type RSimUpdateContextProps = {
  updateTagsForRSim: (euicc: string, tags: any) => void;
};

const rSimUpdateContext = createContext<RSimUpdateContextProps>({} as RSimUpdateContextProps);

export const RSimUpdateProvider = ({ queryKey, children }: any) => {
  const queryClient = useQueryClient();
  const updateTagsForRSim = (euicc: string, tags: any) => {
    const simProfiles: RSimsData | undefined = queryClient.getQueryData(queryKey);

    if (!simProfiles?.items.length) {
      return;
    }

    queryClient.setQueryData(queryKey, (oldData: RSimsData) => {
      if (!oldData) {
        return oldData;
      }

      const newData = {
        ...oldData,
        items: oldData?.items.map((simProfile: RSimInventoryItem) => {
          if (simProfile.euicc === euicc) {
            return { ...simProfile, tags: { items: tags, hasMore: false } };
          }

          return simProfile;
        }),
      };

      return newData;
    });
  };

  return (
    <rSimUpdateContext.Provider value={{ updateTagsForRSim }}>
      {children}
    </rSimUpdateContext.Provider>
  );
};
